import { Header } from "@/components/SiteUI"
import questions from "./data/young";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { YoungResults } from "./results/YoungResults";
import { useNavigate, useSearchParams } from "react-router-dom";
import tests from "@/shared/api/tests";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useAnonResults } from "@/hooks/useAnonResults";


export const YoungTest = () => {
    const [searchParams] = useSearchParams();
    const [scores, setScores] = useState([]);
    const [question, setQuestion] = useState(0);

    const navigate = useNavigate();
    const { isAuth, loading } = useAuth();
    const { saveResult } = useAnonResults();

    const handleAnswerClick = async (id, score) => {
        if (question === questions.length - 1) {
            try {
                const res = await tests.saveYoungTest(scores.map((el) => el.score));
                console.log(res.data)
                if (res.data?._id) {
                    toast.success("Тест сохранен");
                    if (!isAuth && !loading) {
                        saveResult(res.data._id);
                    }
                    navigate(`/tests/results/${res.data?._id}`)
                }
            } catch (err) {
                console.error(err);
                toast.error("Ошибка сохранения теста");
            }
        }
        setScores(prev => [...prev, { id, score }]);
        setQuestion(question + 1);
    }

    useEffect(() => {
        const results = searchParams.get("results")?.split("").map(el => parseInt(el));
        if (results) {
            setScores(results.map((el, i) => ({ id: i + 1, score: el })));
            setQuestion(results.length);
        }
    }, [searchParams])

    return (
        <div className="min-h-screen px-4 sm:px-8 py-8">
            <Header />
            <div className="bg-card rounded-lg border p-6 mt-16">
                <h2 className="my-4 text-center">Опросник Дж.Янга по Определению Схем</h2>
                <div>
                    <p>
                        Ниже перечислены утверждения, с помощью которых Вы можете
                        описать себя. Пожалуйста, прочитайте каждое утверждение и решите,
                        насколько точно оно соответствует Вам. Если Вы не уверены, как ответить,
                        основывайте свой ответ на том, как Вы ЧУВСТВУЕТЕ, а не на том, что Вы
                        считаете правильным.
                    </p>
                </div>

                <div className="flex flex-col rounded-lg border items-center justify-start">

                    {questions[question]?.id ? (
                        <div className="flex flex-col items-center gap-4 mb-4 w-full">
                            <h3 className="text-center">{questions[question].question}</h3>

                            <div className="flex flex-col gap-2 max-w-lg w-full">
                                <Button variant="outline" onClick={() => handleAnswerClick(questions[question].id, 6)}>
                                    Полностью соответствует
                                </Button>
                                <Button variant="outline" onClick={() => handleAnswerClick(questions[question].id, 5)}>
                                    По большей части соответствует
                                </Button>
                                <Button variant="outline" onClick={() => handleAnswerClick(questions[question].id, 4)}>
                                    Скорее соответствует
                                </Button>
                                <Button variant="outline" onClick={() => handleAnswerClick(questions[question].id, 3)}>
                                    Скорее не соответствует, чем соответствует
                                </Button>
                                <Button variant="outline" onClick={() => handleAnswerClick(questions[question].id, 2)}>
                                    По большей части не соответствует
                                </Button>
                                <Button variant="outline" onClick={() => handleAnswerClick(questions[question].id, 1)}>
                                    Абсолютно не соответствует
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div className="w-64 h-64 flex flex-col gap-4 pt-12 items-center justify-center">
                            <Loader2 className="w-12 h-12 animate-spin" />
                            <span className="text-muted-foreground">Обработка результатов...</span>
                        </div>
                    )}
                    <div className="mt-4 flex flex-col items-center gap-2 w-full">
                        <div className="h-1 w-full bg-neutral-200 dark:bg-neutral-600">
                            <div className="h-1 bg-primary transition-all" style={{ width: `${100 / questions.length * (question + 1)}%` }} />
                        </div>
                        <span className="text-muted-foreground">{question + 1} из {questions.length}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}